<div [id]="mapId" class="grid-card-map"></div>
